import React from "react";
import { Button } from "react-bootstrap";
import { GenericModal } from "./GenericModal";

const SuccessModal = ({ isOpen, onClose, title, message, icon }) => {
    const modalContent = (
        <div className="text-center">
            <div className="mx-auto d-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-25 mb-3" style={{ height: "64px", width: "64px" }}>
                {icon}
            </div>

            <p className="fs-5">{message}</p>
        </div>
    );

    const footerActions = (
        <Button variant="primary" onClick={onClose} className="w-100">
            Great
        </Button>
    );

    return (
        <GenericModal show={isOpen} handleClose={onClose} title={title} footerActions={footerActions}>
            {modalContent}
        </GenericModal>
    );
};

export default SuccessModal;
